import { render, staticRenderFns } from "./HowToBid.vue?vue&type=template&id=ede7b97e&scoped=true&"
import script from "./HowToBid.vue?vue&type=script&lang=ts&"
export * from "./HowToBid.vue?vue&type=script&lang=ts&"
import style0 from "./HowToBid.vue?vue&type=style&index=0&id=ede7b97e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede7b97e",
  null
  
)

export default component.exports